import { watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMessage } from 'naive-ui'
import { useAgentStore } from '../stores/agent'
import { shortThread } from './shortThread'

// `lastNotified` flips whenever a web /agent session's turn crossed the
// server's long-running threshold (2 min, #855) — quick turns stay silent
// since the user is still watching the tab.
//
// Unlike useIngestCompletionToast's `lastCompleted` (which is ALSO written
// by source_activity's `load()` REST catch-up after a reconnect, so its
// first post-mount emission can replay a transition the user already saw),
// `lastNotified` is written ONLY by AgentSessionsChannel's live `received()`
// handler — never backfilled. And unlike source_activity's channel, the
// sessions-list subscription is never torn down on navigation (no
// `unsubscribe` wired in useAdminSubscriptions), so it doesn't reconnect
// each time this composable remounts either. There is nothing to skip: a
// watch() callback only fires on an actual live change to `.value`.
//
// Requires NMessageProvider in the tree (App.vue mounts one).
export function useAgentFeedbackToast(): void {
  const store = useAgentStore()
  const { lastNotified, activeThreadId } = storeToRefs(store)
  const message = useMessage()

  watch(lastNotified, (session) => {
    if (!session) return
    // Already looking at this session's live transcript — the reply is
    // visible on-screen, a toast on top would just be noise.
    if (session.thread_id === activeThreadId.value) return
    const label = session.name || shortThread(session.thread_id)
    message.info(`Agent finished: ${label}`)
  })
}
